import React, { useEffect, useRef } from "react";
import SlickSlider from "react-slick";

// react-slick marks off-screen and cloned slides aria-hidden="true" but leaves
// the links inside them focusable, so keyboard users tab into slides they
// can't see (Lighthouse aria-hidden-focus). Take those links out of the tab
// order whenever slick changes which slides are visible.
const FOCUSABLE = "a[href], button, input, select, textarea, [tabindex]";

const syncFocus = (slider) => {
  const list = slider && slider.innerSlider && slider.innerSlider.list;
  if (!list) return;
  list.querySelectorAll(".slick-slide").forEach((slide) => {
    const hidden = slide.getAttribute("aria-hidden") === "true";
    slide.querySelectorAll(FOCUSABLE).forEach((el) => {
      if (hidden) el.setAttribute("tabindex", "-1");
      else if (el.getAttribute("tabindex") === "-1")
        el.removeAttribute("tabindex");
    });
  });
};

export const Slider = ({ onInit, onReInit, afterChange, ...props }) => {
  const slider = useRef(null);
  const sync = () => syncFocus(slider.current);
  useEffect(sync);
  return (
    <SlickSlider
      ref={slider}
      onInit={(...args) => {
        sync();
        if (onInit) onInit(...args);
      }}
      onReInit={(...args) => {
        sync();
        if (onReInit) onReInit(...args);
      }}
      afterChange={(...args) => {
        sync();
        if (afterChange) afterChange(...args);
      }}
      {...props}
    />
  );
};

export default Slider;
